/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

  // src/js/fd-signup.js
  (function() {
    "use strict";
    if (window.__fdSignupLoaded) return;
    window.__fdSignupLoaded = true;
    var MIN_FREE_TEXT = 5;
    var MAX_ROWS = 8;
    var WHY_MAX_HEIGHT = 196;
    var BLUR_CLOSE_DELAY = 160;
    var instances = {};
    var indexCache = {};
    function fold(value) {
      return (value || "").normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/['‘’.]/g, "").replace(/[^a-z0-9]+/gi, " ").replace(/^ | $/g, "").toLowerCase();
    }
    __name(fold, "fold");
    function tokenise(value) {
      var out = [];
      var parts = fold(value).split(" ");
      for (var i = 0; i < parts.length; i++) {
        if (parts[i]) out.push(parts[i]);
      }
      return out;
    }
    __name(tokenise, "tokenise");
    function normalisePhone(raw) {
      var text = (raw || "").trim();
      if (!text) return { ok: false };
      var digits = text.replace(/\D/g, "");
      if (digits.indexOf("00353") === 0) {
        digits = digits.slice(5);
      } else if (digits.indexOf("353") === 0) {
        digits = digits.slice(3);
      }
      digits = digits.replace(/^0+/, "");
      if (!/^8[2-9]\d{7}$/.test(digits)) return { ok: false };
      return { ok: true, e164: "+353" + digits };
    }
    __name(normalisePhone, "normalisePhone");
    function prettyPhone(e164) {
      var n = e164.slice(4);
      return "+353 " + n.slice(0, 2) + " " + n.slice(2, 5) + " " + n.slice(5);
    }
    __name(prettyPhone, "prettyPhone");
    function emailValid(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || "").trim());
    }
    __name(emailValid, "emailValid");
    function fill(template, tokens) {
      var out = template || "";
      for (var key in tokens) {
        if (Object.prototype.hasOwnProperty.call(tokens, key)) {
          out = out.split("{" + key + "}").join(tokens[key]);
        }
      }
      return out;
    }
    __name(fill, "fill");
    function show(el, visible) {
      if (el) el.hidden = !visible;
    }
    __name(show, "show");
    function setText(el, text) {
      if (el) el.textContent = text;
    }
    __name(setText, "setText");
    function isOn(root, name) {
      return root.getAttribute("data-fd-" + name) === "true";
    }
    __name(isOn, "isOn");
    function str(root, name) {
      return root.getAttribute("data-fd-str-" + name) || "";
    }
    __name(str, "str");
    function schoolIsLive(value) {
      return value === "l" || value === "live";
    }
    __name(schoolIsLive, "schoolIsLive");
    function normaliseIndex(data) {
      if (Array.isArray(data)) return data;
      if (!data || !Array.isArray(data.schools)) return [];
      var rows = data.schools;
      if (!rows.length) return [];
      if (!Array.isArray(rows[0])) return rows;
      var fields = Array.isArray(data.fields) ? data.fields : [];
      if (!fields.length) return [];
      var out = [];
      for (var i = 0; i < rows.length; i++) {
        var school = {};
        for (var f = 0; f < fields.length; f++) {
          school[fields[f]] = rows[i][f];
        }
        out.push(school);
      }
      return out;
    }
    __name(normaliseIndex, "normaliseIndex");
    function loadIndex(url) {
      if (indexCache[url]) return indexCache[url];
      indexCache[url] = fetch(url, { credentials: "omit" }).then(function(response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      }).then(normaliseIndex).catch(function() {
        return [];
      });
      return indexCache[url];
    }
    __name(loadIndex, "loadIndex");
    function Instance(root) {
      this.root = root;
      this.id = root.getAttribute("data-fd-section-id");
      this.formType = root.getAttribute("data-fd-form-type") || "card";
      this.form = root.querySelector("[data-fd-form]");
      this.submit = root.querySelector("[data-fd-submit]");
      this.formError = root.querySelector("[data-fd-form-error]");
      this.success = root.querySelector("[data-fd-success]");
      this.successText = root.querySelector("[data-fd-success-text]");
      this.head = root.querySelector("[data-fd-head]");
      this.wantsWhatsApp = isOn(root, "collect-whatsapp");
      this.wantsEmail = isOn(root, "collect-email");
      this.wantsSchool = isOn(root, "check-school");
      this.schoolLocked = isOn(root, "school-locked");
      this.showCount = isOn(root, "show-count");
      this.countTemplate = root.getAttribute("data-fd-count-template") || "";
      this.countZero = root.getAttribute("data-fd-count-zero") || "";
      this.minCount = parseInt(root.getAttribute("data-fd-min-count"), 10);
      if (isNaN(this.minCount)) this.minCount = 1;
      this.indexUrl = root.getAttribute("data-fd-index-url") || "";
      this.endpoint = root.getAttribute("data-fd-endpoint") || "";
      this.statusEndpoint = root.getAttribute("data-fd-status-endpoint") || "";
      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      this.schools = null;
      this.matches = [];
      this.activeIndex = -1;
      this.selected = null;
      this.freeText = false;
      this.open = false;
      this.sending = false;
      this.countRequest = null;
      this.statusRequest = null;
      this.closeTimer = null;
      this.listeners = [];
      this.stripChannel = "whatsapp";
      this.bind();
      this.stampTimestamp();
      this.refreshSubmit();
    }
    __name(Instance, "Instance");
    Instance.prototype.on = function(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push([target, type, handler, options]);
    };
    Instance.prototype.destroy = function() {
      for (var i = 0; i < this.listeners.length; i++) {
        var l = this.listeners[i];
        l[0].removeEventListener(l[1], l[2], l[3]);
      }
      this.listeners = [];
      if (this.closeTimer) clearTimeout(this.closeTimer);
      if (this.shareCopyTimer) clearTimeout(this.shareCopyTimer);
    };
    Instance.prototype.stampTimestamp = function() {
      var ts = this.root.querySelector("[data-fd-ts]");
      if (ts) ts.value = String(Date.now());
    };
    Instance.prototype.bind = function() {
      var self = this;
      this.schoolInput = this.root.querySelector("[data-fd-school-input]");
      this.listbox = this.root.querySelector("[data-fd-school-list]");
      this.schoolError = this.root.querySelector("[data-fd-school-error]");
      this.schoolStatus = this.root.querySelector("[data-fd-school-status]");
      this.freeFoot = this.root.querySelector("[data-fd-free-foot]");
      this.freeNote = this.root.querySelector("[data-fd-free-note]");
      this.searchInstead = this.root.querySelector("[data-fd-search-instead]");
      this.rollField = this.root.querySelector("[data-fd-roll]");
      this.handleField = this.root.querySelector("[data-fd-handle]");
      this.freeTextField = this.root.querySelector("[data-fd-free-text]");
      this.countLine = this.root.querySelector("[data-fd-count]");
      this.phone = this.root.querySelector("[data-fd-phone]");
      this.phoneGroup = this.root.querySelector("[data-fd-phone-group]");
      this.phoneTick = this.root.querySelector("[data-fd-phone-tick]");
      this.phoneError = this.root.querySelector("[data-fd-phone-error]");
      this.phoneHint = this.root.querySelector("[data-fd-phone-hint]");
      this.email = this.root.querySelector("[data-fd-email]");
      this.emailError = this.root.querySelector("[data-fd-email-error]");
      this.role = this.root.querySelector("[data-fd-role]");
      this.over16Row = this.root.querySelector("[data-fd-over16-row]");
      this.over16 = this.root.querySelector("[data-fd-over16]");
      this.waConsent = this.root.querySelector("[data-fd-wa-consent]");
      this.emailConsent = this.root.querySelector("[data-fd-email-consent]");
      this.waConsentRow = this.root.querySelector("[data-fd-wa-consent-row]");
      this.emailConsentRow = this.root.querySelector("[data-fd-email-consent-row]");
      this.consentSingle = this.root.querySelector("[data-fd-consent-single]");
      this.consentLabel = this.root.querySelector("[data-fd-consent-label]");
      this.why = this.root.querySelector("[data-fd-why]");
      if (this.searchInstead) setText(this.searchInstead, str(this.root, "search-instead"));
      if (this.schoolInput) {
        this.on(this.schoolInput, "input", function() {
          self.onSchoolInput();
        });
        this.on(this.schoolInput, "focus", function() {
          self.onSchoolFocus();
        });
        this.on(this.schoolInput, "blur", function() {
          self.onSchoolBlur();
        });
        this.on(this.schoolInput, "keydown", function(event) {
          self.onSchoolKeydown(event);
        });
      }
      if (this.listbox) {
        this.on(this.listbox, "mousedown", function(event) {
          var option = event.target.closest("[data-fd-option]");
          if (!option) return;
          event.preventDefault();
          self.choose(parseInt(option.getAttribute("data-fd-option"), 10));
        });
      }
      if (this.searchInstead) {
        this.on(this.searchInstead, "click", function() {
          self.leaveFreeText();
        });
      }
      if (this.phone) {
        this.on(this.phone, "input", function() {
          self.clearPhoneState();
          self.refreshSubmit();
        });
        this.on(this.phone, "blur", function() {
          self.validatePhone();
        });
        this.on(this.phone, "focus", function() {
          self.clearPhoneState();
        });
      }
      if (this.email) {
        this.on(this.email, "input", function() {
          self.clearEmailState();
          self.refreshSubmit();
        });
        this.on(this.email, "blur", function() {
          self.validateEmail();
        });
      }
      if (this.role && this.role.tagName === "SELECT") {
        this.on(this.role, "change", function() {
          self.onRoleChange();
        });
      }
      if (this.why) {
        this.on(this.why, "input", function() {
          self.autoGrow();
        });
        this.autoGrow();
      }
      if (this.over16) {
        this.on(this.over16, "change", function() {
          self.refreshSubmit();
        });
      }
      if (this.waConsent) {
        this.on(this.waConsent, "change", function() {
          self.refreshSubmit();
        });
      }
      if (this.emailConsent) {
        this.on(this.emailConsent, "change", function() {
          self.refreshSubmit();
        });
      }
      if (this.consentSingle) {
        this.on(this.consentSingle, "change", function() {
          self.refreshSubmit();
        });
      }
      if (this.form) {
        this.on(this.form, "submit", function(event) {
          event.preventDefault();
          self.onSubmit();
        });
      }
      if (this.submit) {
        this.on(this.submit, "click", function(event) {
          if (self.sending) {
            event.preventDefault();
            return;
          }
          if (self.submit.getAttribute("aria-disabled") !== "true") return;
          event.preventDefault();
          self.reportIncomplete();
        });
      }
      var pills = this.root.querySelectorAll("[data-fd-role-pill]");
      for (var p = 0; p < pills.length; p++) {
        (function(pill) {
          self.on(pill, "click", function() {
            self.onRolePick(pill.getAttribute("data-fd-role-pill"));
          });
        })(pills[p]);
      }
      this.bindShare();
      if (this.formType === "strip") this.bindStrip();
      if (this.formType === "school-page") this.bindSchoolPage();
      if (this.formType === "takeover") this.bindTakeover();
    };
    Instance.prototype.bindShare = function() {
      var self = this;
      var root = this.root;
      this.shareNative = root.querySelector("[data-fd-share-native]");
      this.shareCopy = root.querySelector("[data-fd-share-copy]");
      this.shareWrap = root.querySelector("[data-fd-share-wrap]");
      if (!this.shareNative && !this.shareCopy) return;
      if (this.shareNative && navigator.share) {
        show(this.shareNative, true);
        this.on(this.shareNative, "click", function() {
          navigator.share({
            title: root.getAttribute("data-fd-share-title") || "",
            text: root.getAttribute("data-fd-share-message") || "",
            url: root.getAttribute("data-fd-share-url") || ""
          }).catch(function() {
          });
        });
      }
      if (this.shareCopy) {
        var label = root.querySelector("[data-fd-share-copy-label]");
        var status = root.querySelector("[data-fd-share-status]");
        this.on(this.shareCopy, "click", function() {
          var url = root.getAttribute("data-fd-share-url") || "";
          var done = /* @__PURE__ */ __name(function() {
            setText(label, str(root, "share-copied"));
            setText(status, str(root, "share-copied"));
            if (self.shareCopyTimer) clearTimeout(self.shareCopyTimer);
            self.shareCopyTimer = setTimeout(function() {
              setText(label, str(root, "share-copy"));
              setText(status, "");
            }, 1600);
          }, "done");
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done, function() {
              self.shareCopyFallback(url);
              done();
            });
          } else {
            self.shareCopyFallback(url);
            done();
          }
        });
      }
    };
    Instance.prototype.shareCopyFallback = function(url) {
      var area = document.createElement("textarea");
      area.value = url;
      area.setAttribute("readonly", "");
      area.style.position = "absolute";
      area.style.left = "-9999px";
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand("copy");
      } catch (err) {
      }
      document.body.removeChild(area);
    };
    Instance.prototype.bindStrip = function() {
      var self = this;
      this.strip = this.root.querySelector("[data-fd-strip]");
      this.armBtn = this.root.querySelector("[data-fd-arm]");
      this.swapBtn = this.root.querySelector("[data-fd-swap]");
      if (this.armBtn) {
        this.on(this.armBtn, "click", function() {
          self.armStrip(true);
        });
      }
      if (this.swapBtn) {
        this.on(this.swapBtn, "click", function() {
          self.swapStripChannel();
        });
      }
      if (this.strip && this.strip.hasAttribute("data-fd-strip-open")) this.armStrip(false);
    };
    Instance.prototype.armStrip = function(focusField) {
      if (this.strip) this.strip.classList.add("is-armed");
      if (focusField) {
        var field = this.stripChannel === "whatsapp" ? this.phone : this.email;
        if (field && field.focus) field.focus();
      }
    };
    Instance.prototype.swapStripChannel = function() {
      this.stripChannel = this.stripChannel === "whatsapp" ? "email" : "whatsapp";
      var wa = this.stripChannel === "whatsapp";
      show(this.phone, wa);
      show(this.email, !wa);
      if (this.swapBtn) {
        setText(this.swapBtn, this.root.getAttribute(wa ? "data-fd-strip-swap-email" : "data-fd-strip-swap-phone") || "");
      }
      this.clearPhoneState();
      this.clearEmailState();
      this.refreshSubmit();
      var field = wa ? this.phone : this.email;
      if (field && field.focus) field.focus();
    };
    Instance.prototype.updateHeroConsent = function() {
      if (this.formType !== "hero") return;
      var pFilled = !!(this.phone && this.phone.value.trim());
      var eFilled = !!(this.email && this.email.value.trim());
      var both = pFilled && eFilled;
      show(this.emailConsentRow, both);
      if (this.consentLabel) {
        var label;
        if (pFilled) label = this.root.getAttribute("data-fd-hero-wa-label");
        else if (eFilled) label = this.root.getAttribute("data-fd-hero-email-label");
        else label = this.root.getAttribute("data-fd-hero-base-label");
        setText(this.consentLabel, label || "");
      }
    };
    Instance.prototype.bindSchoolPage = function() {
      this.roleGate = this.root.querySelector("[data-fd-role-gate]");
      this.roleCopy = this.root.querySelector("[data-fd-role-copy]");
      this.submitLabel = this.root.querySelector("[data-fd-submit-label]");
      this.badge = this.root.querySelector("[data-fd-badge]");
      this.badgeText = this.root.querySelector("[data-fd-badge-text]");
      this.refreshBadge();
    };
    Instance.prototype.refreshBadge = function() {
      var self = this;
      var roll = this.rollField && this.rollField.value;
      if (!this.badge || !this.statusEndpoint || !roll) return;
      var template = this.root.getAttribute("data-fd-badge-template") || "";
      fetch(this.statusEndpoint + "?roll=" + encodeURIComponent(roll), { credentials: "omit" }).then(function(response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      }).then(function(data) {
        var parsed = parseInt(data && data.count, 10);
        if (isNaN(parsed) || parsed < self.minCount || !template) {
          show(self.badge, false);
          return;
        }
        setText(self.badgeText, fill(template, { count: parsed }));
        show(self.badge, true);
      }).catch(function() {
      });
    };
    Instance.prototype.onRolePick = function(role) {
      if (this.role) this.role.value = role;
      var pills = this.root.querySelectorAll("[data-fd-role-pill]");
      for (var i = 0; i < pills.length; i++) {
        var active = pills[i].getAttribute("data-fd-role-pill") === role;
        pills[i].classList.toggle("is-on", active);
        pills[i].setAttribute("aria-pressed", active ? "true" : "false");
      }
      if (this.roleGate) show(this.roleGate, true);
      if (this.roleCopy) {
        var copy = this.root.getAttribute("data-fd-copy-" + role) || "";
        setText(this.roleCopy, copy);
        show(this.roleCopy, !!copy);
      }
      if (this.submitLabel) {
        var cta = this.root.getAttribute("data-fd-cta-" + role);
        if (cta) setText(this.submitLabel, cta);
      }
      this.autoGrow();
      this.onRoleChange();
    };
    Instance.prototype.bindTakeover = function() {
      var self = this;
      this.tkSearchWrap = this.root.querySelector("[data-fd-tk-search-wrap]");
      this.tkResult = this.root.querySelector("[data-fd-tk-result]");
      this.tkIn = this.root.querySelector("[data-fd-tk-in]");
      this.tkInTitle = this.root.querySelector("[data-fd-tk-in-title]");
      this.tkNotyet = this.root.querySelector("[data-fd-tk-notyet]");
      this.tkHead = this.root.querySelector("[data-fd-tk-head]");
      this.tkCopy = this.root.querySelector("[data-fd-tk-copy]");
      this.tkAgain = this.root.querySelector("[data-fd-tk-again]");
      if (this.tkAgain) {
        this.on(this.tkAgain, "click", function() {
          self.tkReset();
        });
      }
    };
    Instance.prototype.tkShowResult = function(school) {
      var self = this;
      show(this.tkSearchWrap, false);
      show(this.tkResult, true);
      if (!school) {
        this.tkRender(false, null, null);
        return;
      }
      this.tkRender(schoolIsLive(school.s) || schoolIsLive(school.status), school, null);
      if (!this.statusEndpoint || !school.roll) return;
      var request = this.statusRequest = {};
      var url = this.statusEndpoint + "?roll=" + encodeURIComponent(school.roll) + (school.slug ? "&handle=" + encodeURIComponent(school.slug) : "");
      fetch(url, { credentials: "omit" }).then(function(response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      }).then(function(data) {
        if (self.statusRequest !== request || self.selected !== school) return;
        self.tkRender(schoolIsLive(data && data.status), school, data && data.count);
      }).catch(function() {
      });
    };
    Instance.prototype.tkRender = function(isLive, school, count) {
      var name = school ? school.name : this.schoolInput ? this.schoolInput.value.trim() : "";
      if (isLive) {
        var heading = this.root.getAttribute("data-fd-tk-in-heading") || "";
        setText(this.tkInTitle, fill(heading, { school: name }));
        show(this.tkIn, true);
        show(this.tkNotyet, false);
        return;
      }
      var copyTemplate = this.root.getAttribute("data-fd-tk-notyet-copy") || "";
      var zeroTemplate = this.root.getAttribute("data-fd-tk-notyet-zero") || "";
      var parsed = parseInt(count, 10);
      var text;
      if (!isNaN(parsed) && parsed >= this.minCount && copyTemplate) {
        text = fill(copyTemplate, { count: parsed, school: name });
      } else {
        text = fill(zeroTemplate, { school: name });
      }
      setText(this.tkCopy, text);
      show(this.tkCopy, !!text);
      show(this.tkIn, false);
      show(this.tkNotyet, true);
      this.autoGrow();
    };
    Instance.prototype.tkReset = function() {
      show(this.tkResult, false);
      show(this.tkIn, false);
      show(this.tkNotyet, false);
      show(this.tkSearchWrap, true);
      if (this.form && this.success && this.success.hidden) {
        show(this.form, true);
        show(this.tkHead, true);
      }
      this.selected = null;
      if (this.rollField) this.rollField.value = "";
      if (this.handleField) this.handleField.value = "";
      if (this.freeText) {
        this.leaveFreeText();
        return;
      }
      if (this.schoolInput) {
        this.schoolInput.value = "";
        this.schoolInput.classList.remove("is-valid", "is-error");
        this.setSchoolError("");
        this.schoolInput.focus();
      }
      this.refreshSubmit();
    };
    Instance.prototype.ensureIndex = function() {
      var self = this;
      if (this.schools) return Promise.resolve(this.schools);
      return loadIndex(this.indexUrl).then(function(list) {
        self.schools = list;
        return list;
      });
    };
    Instance.prototype.onSchoolFocus = function() {
      var self = this;
      if (this.freeText) return;
      this.ensureIndex().then(function() {
        if (self.schoolInput.value.trim() && !self.selected) self.openList();
      });
    };
    Instance.prototype.onSchoolInput = function() {
      var self = this;
      this.selected = null;
      this.setSchoolError("");
      this.hideCount();
      if (this.rollField) this.rollField.value = "";
      if (this.freeTextField) {
        this.freeTextField.value = this.freeText ? this.schoolInput.value.trim() : "";
      }
      this.schoolInput.classList.remove("is-valid");
      if (this.freeText) {
        this.refreshSubmit();
        return;
      }
      this.ensureIndex().then(function() {
        self.openList();
        self.refreshSubmit();
      });
    };
    Instance.prototype.onSchoolBlur = function() {
      var self = this;
      if (this.freeText) {
        this.commitFreeText();
        return;
      }
      this.closeTimer = setTimeout(function() {
        self.closeList();
        if (self.selected) self.schoolInput.classList.add("is-valid");
      }, BLUR_CLOSE_DELAY);
    };
    Instance.prototype.onSchoolKeydown = function(event) {
      if (this.freeText) return;
      var key = event.key;
      if (key === "ArrowDown" || key === "ArrowUp") {
        event.preventDefault();
        if (!this.open) {
          this.openList();
          return;
        }
        var total = this.optionCount();
        if (!total) return;
        var step = key === "ArrowDown" ? 1 : -1;
        this.setActive((this.activeIndex + step + total) % total);
        return;
      }
      if (key === "Enter") {
        if (!this.open || this.activeIndex < 0) return;
        event.preventDefault();
        this.choose(this.activeIndex);
        return;
      }
      if (key === "Escape") {
        if (!this.open) return;
        event.preventDefault();
        this.closeList();
        return;
      }
      if (key === "Tab" && this.open) this.closeList();
    };
    Instance.prototype.optionCount = function() {
      return Math.min(this.matches.length, MAX_ROWS) + 1;
    };
    Instance.prototype.matchesFor = function(query) {
      var tokens = tokenise(query);
      if (!tokens.length) return [];
      var list = this.schools || [];
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var school = list[i];
        if (!school.words) {
          school.words = tokenise([school.search, school.name, school.address, school.roll].join(" "));
        }
        var words = school.words;
        var matched = true;
        for (var t = 0; t < tokens.length; t++) {
          var token = tokens[t];
          var found = false;
          for (var w = 0; w < words.length; w++) {
            if (words[w].lastIndexOf(token, 0) === 0) {
              found = true;
              break;
            }
          }
          if (!found) {
            matched = false;
            break;
          }
        }
        if (matched) out.push(school);
      }
      return out;
    };
    Instance.prototype.openList = function() {
      if (this.closeTimer) clearTimeout(this.closeTimer);
      var query = this.schoolInput.value.trim();
      if (!query) {
        this.closeList();
        return;
      }
      this.matches = this.matchesFor(query);
      this.renderList(query);
      this.open = true;
      this.listbox.hidden = false;
      this.schoolInput.setAttribute("aria-expanded", "true");
      this.schoolInput.classList.add("is-open");
      var openWrapper = this.root.closest(".shopify-section");
      if (openWrapper) openWrapper.classList.add("fd-signup-section--raised");
      this.setActive(-1);
    };
    Instance.prototype.closeList = function() {
      this.open = false;
      this.activeIndex = -1;
      var closeWrapper = this.root.closest(".shopify-section");
      if (closeWrapper) closeWrapper.classList.remove("fd-signup-section--raised");
      if (this.schoolStatus) setText(this.schoolStatus, "");
      if (this.listbox) {
        this.listbox.hidden = true;
        this.listbox.innerHTML = "";
      }
      if (this.schoolInput) {
        this.schoolInput.setAttribute("aria-expanded", "false");
        this.schoolInput.removeAttribute("aria-activedescendant");
        this.schoolInput.classList.remove("is-open");
      }
    };
    Instance.prototype.renderList = function(query) {
      var shown = this.matches.slice(0, MAX_ROWS);
      var total = this.matches.length;
      var html = "";
      var summaryText = "";
      if (total > 0) {
        if (total > MAX_ROWS) {
          summaryText = fill(str(this.root, "results-narrow"), { count: total });
        } else if (total === 1) {
          summaryText = str(this.root, "results-one");
        } else {
          summaryText = fill(str(this.root, "results-many"), { count: total });
        }
        html += '<li class="fd-signup__listbox-summary" role="presentation">' + escapeHtml(summaryText) + "</li>";
      }
      for (var i = 0; i < shown.length; i++) {
        var chip = "";
        if (this.formType === "takeover") {
          var live = schoolIsLive(shown[i].s) || schoolIsLive(shown[i].status);
          chip = '<span class="fd-signup__chip ' + (live ? "fd-signup__chip--in" : "fd-signup__chip--notyet") + '">' + escapeHtml(str(this.root, live ? "chip-in" : "chip-not-yet")) + "</span>";
        }
        html += '<li class="fd-signup__option" role="option" aria-selected="false" id="fd-opt-' + this.id + "-" + i + '" data-fd-option="' + i + '"><span class="fd-signup__option-main"><span class="fd-signup__option-name">' + escapeHtml(shown[i].name) + '</span><span class="fd-signup__option-address">' + escapeHtml(shown[i].address || "") + "</span></span>" + chip + "</li>";
      }
      var addIndex = shown.length;
      var addLabel = total === 0 ? fill(str(this.root, "no-match"), { query }) : str(this.root, "add-manually");
      if (total === 0 && !(this.schools && this.schools.length)) {
        addLabel = str(this.root, "index-failed");
      }
      html += '<li class="fd-signup__option fd-signup__option--add' + (total === 0 ? " fd-signup__option--nomatch" : "") + '" role="option" aria-selected="false" id="fd-opt-' + this.id + "-" + addIndex + '" data-fd-option="' + addIndex + '"><span class="fd-signup__option-add">' + escapeHtml(addLabel) + "</span></li>";
      this.listbox.innerHTML = html;
      if (this.schoolStatus) {
        setText(this.schoolStatus, total > 0 ? summaryText : addLabel);
      }
    };
    Instance.prototype.setActive = function(index) {
      var options = this.listbox.querySelectorAll("[data-fd-option]");
      for (var i = 0; i < options.length; i++) {
        var active = i === index;
        options[i].classList.toggle("is-active", active);
        options[i].setAttribute("aria-selected", active ? "true" : "false");
      }
      this.activeIndex = index;
      if (index < 0) {
        this.schoolInput.removeAttribute("aria-activedescendant");
        return;
      }
      this.schoolInput.setAttribute("aria-activedescendant", "fd-opt-" + this.id + "-" + index);
      if (options[index] && options[index].scrollIntoView) {
        options[index].scrollIntoView({ block: "nearest" });
      }
    };
    Instance.prototype.choose = function(index) {
      var shown = this.matches.slice(0, MAX_ROWS);
      if (index >= shown.length) {
        this.enterFreeText();
        return;
      }
      var school = shown[index];
      this.selected = school;
      this.schoolInput.value = school.name;
      if (this.rollField) this.rollField.value = school.roll || "";
      if (this.handleField) this.handleField.value = school.slug || "";
      if (this.freeTextField) this.freeTextField.value = "";
      this.closeList();
      this.schoolInput.classList.add("is-valid");
      this.setSchoolError("");
      if (this.formType === "takeover") {
        this.tkShowResult(school);
      } else {
        this.loadCount(school);
      }
      this.refreshSubmit();
    };
    Instance.prototype.enterFreeText = function() {
      this.freeText = true;
      this.selected = null;
      this.closeList();
      this.hideCount();
      if (this.rollField) this.rollField.value = "";
      this.schoolInput.removeAttribute("role");
      this.schoolInput.removeAttribute("aria-expanded");
      this.schoolInput.removeAttribute("aria-autocomplete");
      this.schoolInput.removeAttribute("aria-controls");
      this.schoolInput.classList.remove("is-valid");
      setText(this.freeNote, str(this.root, "free-note"));
      show(this.freeFoot, true);
      var value = this.schoolInput.value;
      if (this.freeTextField) this.freeTextField.value = value.trim();
      if (this.formType === "takeover") {
        if (value.trim().length >= MIN_FREE_TEXT) {
          this.tkShowResult(null);
        } else {
          this.setSchoolError(str(this.root, "school-short"));
          this.schoolInput.focus();
        }
        this.refreshSubmit();
        return;
      }
      this.schoolInput.focus();
      this.schoolInput.value = "";
      this.schoolInput.value = value;
      this.refreshSubmit();
    };
    Instance.prototype.leaveFreeText = function() {
      this.freeText = false;
      this.selected = null;
      this.schoolInput.value = "";
      if (this.freeTextField) this.freeTextField.value = "";
      this.schoolInput.setAttribute("role", "combobox");
      this.schoolInput.setAttribute("aria-expanded", "false");
      this.schoolInput.setAttribute("aria-autocomplete", "list");
      this.schoolInput.setAttribute("aria-controls", "fd-school-list-" + this.id);
      this.schoolInput.classList.remove("is-error", "is-valid");
      show(this.freeFoot, false);
      this.setSchoolError("");
      this.hideCount();
      this.schoolInput.focus();
      this.refreshSubmit();
    };
    Instance.prototype.commitFreeText = function() {
      var value = this.schoolInput.value.trim();
      if (this.freeTextField) this.freeTextField.value = value;
      if (!value) {
        this.setSchoolError("");
      } else if (value.length < MIN_FREE_TEXT) {
        this.setSchoolError(str(this.root, "school-short"));
      } else {
        this.setSchoolError("");
        this.schoolInput.classList.add("is-valid");
        this.renderCount(null);
      }
      this.refreshSubmit();
    };
    Instance.prototype.setSchoolError = function(message) {
      if (!this.schoolError && this.schoolInput) {
        this.schoolInput.classList.toggle("is-error", !!message);
        return;
      }
      if (!this.schoolError) return;
      setText(this.schoolError, message);
      show(this.schoolError, !!message);
      this.schoolInput.classList.toggle("is-error", !!message);
      if (message) {
        this.schoolInput.setAttribute("aria-invalid", "true");
      } else {
        this.schoolInput.removeAttribute("aria-invalid");
      }
    };
    Instance.prototype.hideCount = function() {
      if (this.countLine && !this.schoolLocked) show(this.countLine, false);
    };
    Instance.prototype.loadCount = function(school) {
      var self = this;
      this.hideCount();
      if (!this.countLine || !this.showCount) return;
      if (!this.statusEndpoint || !school || !school.roll) return;
      var request = this.countRequest = {};
      var url = this.statusEndpoint + "?roll=" + encodeURIComponent(school.roll) + (school.slug ? "&handle=" + encodeURIComponent(school.slug) : "");
      fetch(url, { credentials: "omit" }).then(function(response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      }).then(function(data) {
        if (self.countRequest !== request || self.selected !== school) return;
        self.renderCount(school, data && data.count);
      }).catch(function() {
      });
    };
    Instance.prototype.renderCount = function(school, count) {
      if (!this.countLine || !this.showCount) return;
      var text;
      if (!school) {
        var name = this.schoolInput ? this.schoolInput.value.trim() : "";
        text = this.countZero ? fill(this.countZero, { school: name }) : str(this.root, "count-first");
      } else {
        var parsed = parseInt(count, 10);
        if (isNaN(parsed) || parsed < this.minCount || !this.countTemplate) {
          if (this.countZero) {
            text = fill(this.countZero, { school: school.name });
          } else {
            show(this.countLine, false);
            return;
          }
        } else {
          text = fill(this.countTemplate, { count: parsed, school: school.name });
        }
      }
      if (!text) {
        show(this.countLine, false);
        return;
      }
      this.countLine.innerHTML = '<span class="fd-signup__count-icon" aria-hidden="true"></span>' + escapeHtml(text);
      show(this.countLine, true);
    };
    Instance.prototype.clearPhoneState = function() {
      if (!this.phone) return;
      var box = this.phoneGroup || this.phone;
      box.classList.remove("is-error", "is-valid");
      this.phone.removeAttribute("aria-invalid");
      show(this.phoneTick, false);
      show(this.phoneError, false);
      show(this.phoneHint, false);
    };
    Instance.prototype.validatePhone = function() {
      if (!this.phone) return;
      this.clearPhoneState();
      var raw = this.phone.value.trim();
      if (!raw) {
        this.refreshSubmit();
        return;
      }
      var result = normalisePhone(raw);
      var box = this.phoneGroup || this.phone;
      if (result.ok) {
        box.classList.add("is-valid");
        show(this.phoneTick, true);
        setText(this.phoneHint, fill(str(this.root, "phone-saved"), { phone: prettyPhone(result.e164) }));
        show(this.phoneHint, true);
      } else {
        this.markPhoneInvalid();
      }
      this.refreshSubmit();
    };
    Instance.prototype.markPhoneInvalid = function() {
      if (!this.phone) return;
      var box = this.phoneGroup || this.phone;
      box.classList.add("is-error");
      this.phone.setAttribute("aria-invalid", "true");
      setText(this.phoneError, str(this.root, "phone-invalid"));
      show(this.phoneError, true);
    };
    Instance.prototype.clearEmailState = function() {
      if (!this.email) return;
      this.email.classList.remove("is-error", "is-valid");
      this.email.removeAttribute("aria-invalid");
      show(this.emailError, false);
    };
    Instance.prototype.validateEmail = function() {
      if (!this.email) return;
      this.clearEmailState();
      var raw = this.email.value.trim();
      if (!raw) {
        this.refreshSubmit();
        return;
      }
      if (emailValid(raw)) {
        this.email.classList.add("is-valid");
      } else {
        this.markEmailInvalid();
      }
      this.refreshSubmit();
    };
    Instance.prototype.markEmailInvalid = function() {
      if (!this.email) return;
      this.email.classList.add("is-error");
      this.email.setAttribute("aria-invalid", "true");
      setText(this.emailError, str(this.root, "email-invalid"));
      show(this.emailError, true);
    };
    Instance.prototype.onRoleChange = function() {
      var isStudent = !!this.role && this.role.value === "student";
      if (this.over16Row) show(this.over16Row, isStudent);
      if (this.over16) {
        if (!isStudent) this.over16.checked = false;
        this.over16.required = isStudent;
        if (isStudent) {
          this.over16.setAttribute("aria-required", "true");
        } else {
          this.over16.removeAttribute("aria-required");
        }
      }
      this.refreshSubmit();
    };
    Instance.prototype.autoGrow = function() {
      if (!this.why) return;
      this.why.style.height = "auto";
      if (this.why.scrollHeight === 0) {
        this.why.style.height = "";
        return;
      }
      var height = Math.min(this.why.scrollHeight, WHY_MAX_HEIGHT);
      this.why.style.height = height + "px";
      this.why.style.overflowY = this.why.scrollHeight > WHY_MAX_HEIGHT ? "auto" : "hidden";
    };
    Instance.prototype.schoolOk = function() {
      if (!this.wantsSchool || this.schoolLocked) return true;
      if (!this.schoolInput) return true;
      if (this.freeText) return this.schoolInput.value.trim().length >= MIN_FREE_TEXT;
      return !!this.selected;
    };
    Instance.prototype.channelsOk = function() {
      var pRaw = this.phone ? this.phone.value.trim() : "";
      var eRaw = this.email ? this.email.value.trim() : "";
      var pOk = normalisePhone(pRaw).ok;
      var eOk = emailValid(eRaw);
      if (this.formType === "strip") {
        var activeOk = this.stripChannel === "whatsapp" ? pOk : eOk;
        return activeOk && !!(this.consentSingle && this.consentSingle.checked);
      }
      if (this.formType === "hero") {
        if (!pRaw && !eRaw) return false;
        if (pRaw && !pOk) return false;
        if (eRaw && !eOk) return false;
        if (!(this.consentSingle && this.consentSingle.checked)) return false;
        if (pRaw && eRaw && !(this.emailConsent && this.emailConsent.checked)) return false;
        return true;
      }
      if (!this.wantsWhatsApp && !this.wantsEmail) return false;
      if (this.wantsWhatsApp) {
        if (!pOk) return false;
        if (!(this.waConsent && this.waConsent.checked)) return false;
        if (this.wantsEmail && this.email && eRaw) {
          if (!eOk) return false;
          if (!(this.emailConsent && this.emailConsent.checked)) return false;
        }
        if (this.wantsEmail && this.emailConsent && this.emailConsent.checked && !eOk) return false;
        return true;
      }
      return eOk && !!(this.emailConsent && this.emailConsent.checked);
    };
    Instance.prototype.roleOk = function() {
      if (!this.role || this.role.value !== "student") return true;
      return !!(this.over16 && this.over16.checked);
    };
    Instance.prototype.isValid = function() {
      return this.schoolOk() && this.channelsOk() && this.roleOk();
    };
    Instance.prototype.refreshSubmit = function() {
      this.updateHeroConsent();
      var missing = this.root.querySelectorAll(".is-missing");
      for (var i = 0; i < missing.length; i++) {
        var box = missing[i].querySelector('input[type="checkbox"]');
        if (box && box.checked) missing[i].classList.remove("is-missing");
      }
      if (!this.submit) return;
      var valid = this.isValid();
      this.submit.setAttribute("aria-disabled", valid ? "false" : "true");
      this.submit.classList.toggle("is-blocked", !valid);
      if (valid) show(this.formError, false);
    };
    Instance.prototype.reportIncomplete = function() {
      setText(this.formError, str(this.root, "incomplete"));
      this.formError.classList.remove("fd-signup__error--notice");
      show(this.formError, true);
      var target = null;
      function claim(el) {
        if (!target && el) target = el;
      }
      __name(claim, "claim");
      function markMissing(row) {
        if (row) row.classList.add("is-missing");
      }
      __name(markMissing, "markMissing");
      var pRaw = this.phone ? this.phone.value.trim() : "";
      var eRaw = this.email ? this.email.value.trim() : "";
      var pOk = normalisePhone(pRaw).ok;
      var eOk = emailValid(eRaw);
      if (!this.schoolOk() && this.schoolInput) {
        this.setSchoolError(str(this.root, this.freeText ? "school-short" : "school-missing"));
        claim(this.schoolInput);
      }
      if (this.formType === "strip") {
        var activeField = this.stripChannel === "whatsapp" ? this.phone : this.email;
        var activeOk = this.stripChannel === "whatsapp" ? pOk : eOk;
        if (!activeOk && activeField) {
          activeField.classList.add("is-error");
          claim(activeField);
        }
        if (this.consentSingle && !this.consentSingle.checked) {
          markMissing(this.consentSingle.closest("label"));
          claim(this.consentSingle);
        }
      } else if (this.formType === "hero") {
        if (!pRaw && !eRaw) {
          if (this.phone) this.phone.classList.add("is-error");
          if (this.email) this.email.classList.add("is-error");
          claim(this.phone || this.email);
        }
        if (pRaw && !pOk) {
          this.markPhoneInvalid();
          claim(this.phone);
        }
        if (eRaw && !eOk) {
          this.markEmailInvalid();
          claim(this.email);
        }
        if (this.consentSingle && !this.consentSingle.checked) {
          markMissing(this.waConsentRow);
          claim(this.consentSingle);
        }
        if (pRaw && eRaw && this.emailConsent && !this.emailConsent.checked) {
          markMissing(this.emailConsentRow);
          claim(this.emailConsent);
        }
      } else if (this.wantsWhatsApp) {
        if (!pOk) {
          this.markPhoneInvalid();
          claim(this.phone);
        }
        if (this.waConsent && !this.waConsent.checked) {
          markMissing(this.waConsentRow);
          claim(this.waConsent);
        }
        var emailRequired = this.wantsEmail && this.emailConsent && this.emailConsent.checked;
        if (this.wantsEmail && (eRaw && !eOk || emailRequired && !eOk)) {
          this.markEmailInvalid();
          claim(this.email);
        }
        if (this.wantsEmail && eRaw && eOk && this.emailConsent && !this.emailConsent.checked) {
          markMissing(this.emailConsentRow);
          claim(this.emailConsent);
        }
        if (!this.roleOk()) {
          markMissing(this.over16Row);
          claim(this.over16);
        }
      } else if (this.wantsEmail) {
        if (!eOk) {
          this.markEmailInvalid();
          claim(this.email);
        }
        if (this.emailConsent && !this.emailConsent.checked) {
          markMissing(this.emailConsentRow);
          claim(this.emailConsent);
        }
        if (!this.roleOk()) {
          markMissing(this.over16Row);
          claim(this.over16);
        }
      }
      if (target && target.focus) target.focus();
    };
    Instance.prototype.onSubmit = function() {
      var self = this;
      if (this.sending) return;
      if (!this.isValid()) {
        this.reportIncomplete();
        return;
      }
      show(this.formError, false);
      if (this.designMode || !this.endpoint) {
        this.showSuccess();
        return;
      }
      this.sending = true;
      this.submit.classList.add("is-loading");
      this.submit.setAttribute("aria-busy", "true");
      fetch(this.endpoint, {
        method: "POST",
        credentials: "omit",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.payload())
      }).then(function(response) {
        return response.json().catch(function() {
          return null;
        }).then(function(data) {
          self.settleSubmit();
          self.handleResponse(response.status, data);
        });
      }).catch(function() {
        self.settleSubmit();
        self.showFormNotice(str(self.root, "rate-limited"));
      });
    };
    Instance.prototype.settleSubmit = function() {
      this.sending = false;
      if (this.submit) {
        this.submit.classList.remove("is-loading");
        this.submit.removeAttribute("aria-busy");
      }
    };
    Instance.prototype.payload = function() {
      var path = window.location && window.location.pathname ? window.location.pathname : "";
      if (path === "/" || path === "") path = "/homepage";
      var body = {
        source: "shopify-section" + path,
        form_type: this.formType,
        hp: "",
        ts: null
      };
      var hp = this.form.querySelector('input[name="website"]');
      if (hp) body.hp = hp.value;
      var ts = this.root.querySelector("[data-fd-ts]");
      if (ts && ts.value) body.ts = Number(ts.value) || null;
      if (this.freeText && this.schoolInput) {
        body.school_free_text = this.schoolInput.value.trim();
      } else {
        var roll = this.rollField && this.rollField.value;
        if (roll) body.roll_number = roll;
        if (this.selected && this.selected.slug) {
          body.school_handle = this.selected.slug;
        } else if (this.handleField && this.handleField.value) {
          body.school_handle = this.handleField.value;
        }
      }
      var pRaw = this.phone ? this.phone.value.trim() : "";
      var eRaw = this.email ? this.email.value.trim() : "";
      if (this.formType === "strip") {
        if (this.stripChannel === "whatsapp" && pRaw) {
          body.phone = pRaw;
          body.whatsapp_consent = true;
        } else if (this.stripChannel === "email" && eRaw) {
          body.email = eRaw;
          body.email_consent = true;
        }
      } else if (this.formType === "hero") {
        var mainTicked = !!(this.consentSingle && this.consentSingle.checked);
        if (pRaw && mainTicked) {
          body.phone = pRaw;
          body.whatsapp_consent = true;
        }
        if (eRaw) {
          var emailTicked = pRaw ? !!(this.emailConsent && this.emailConsent.checked) : mainTicked;
          if (emailTicked) {
            body.email = eRaw;
            body.email_consent = true;
          }
        }
      } else {
        if (this.wantsWhatsApp && this.waConsent && this.waConsent.checked && pRaw) {
          body.phone = pRaw;
          body.whatsapp_consent = true;
        }
        if (this.wantsEmail && this.emailConsent && this.emailConsent.checked && eRaw) {
          body.email = eRaw;
          body.email_consent = true;
        }
      }
      var name = this.root.querySelector('input[name="name"]');
      if (name && name.value.trim()) body.name = name.value.trim();
      if (this.role && this.role.value) body.role = this.role.value;
      if (this.over16 && this.over16.checked) body.over_16 = true;
      if (this.why && this.why.value.trim()) body.why = this.why.value.trim();
      return body;
    };
    Instance.prototype.handleResponse = function(status, data) {
      if ((status === 200 || status === 202) && data && data.ok) {
        this.showSuccess();
        return;
      }
      if (status === 422 && data && data.errors) {
        this.showFieldErrors(data.errors);
        return;
      }
      if (status === 403 || status === 429) {
        this.showFormNotice(str(this.root, "rate-limited"));
        return;
      }
      this.showFormNotice(data && data.error || str(this.root, "submit-failed"));
    };
    Instance.prototype.showFieldErrors = function(errors) {
      var focusTarget = null;
      var rest = [];
      for (var key in errors) {
        if (!Object.prototype.hasOwnProperty.call(errors, key)) continue;
        var message = errors[key];
        if (key === "phone" && this.phone) {
          this.clearPhoneState();
          var box = this.phoneGroup || this.phone;
          box.classList.add("is-error");
          this.phone.setAttribute("aria-invalid", "true");
          setText(this.phoneError, message);
          show(this.phoneError, true);
          focusTarget = focusTarget || this.phone;
        } else if (key === "email" && this.email) {
          this.clearEmailState();
          this.email.classList.add("is-error");
          this.email.setAttribute("aria-invalid", "true");
          setText(this.emailError, message);
          show(this.emailError, true);
          focusTarget = focusTarget || this.email;
        } else if (key === "school" && this.schoolInput) {
          this.setSchoolError(message);
          focusTarget = focusTarget || this.schoolInput;
        } else {
          rest.push(message);
        }
      }
      if (rest.length) {
        setText(this.formError, rest.join(" "));
        this.formError.classList.remove("fd-signup__error--notice");
        show(this.formError, true);
      } else {
        show(this.formError, false);
      }
      if (focusTarget && focusTarget.focus) focusTarget.focus();
    };
    Instance.prototype.showFormNotice = function(message) {
      setText(this.formError, message);
      this.formError.classList.add("fd-signup__error--notice");
      show(this.formError, true);
    };
    Instance.prototype.showSuccess = function() {
      show(this.formError, false);
      show(this.form, false);
      if (this.formType === "strip" && this.successText) {
        var key = this.stripChannel === "whatsapp" ? "data-fd-strip-success-wa" : "data-fd-strip-success-email";
        setText(this.successText, this.root.getAttribute(key) || "");
      }
      if (this.formType === "card" || this.formType === "inline" || this.formType === "panel") {
        show(this.head, false);
      }
      if (this.formType === "takeover") {
        show(this.tkHead, false);
      }
      if (this.formType === "strip" && this.strip) {
        this.strip.classList.add("is-sent");
        show(this.shareWrap, true);
      }
      this.root.classList.add("is-done");
      show(this.success, true);
      if (this.successText && this.successText.focus) this.successText.focus();
    };
    function escapeHtml(value) {
      return String(value == null ? "" : value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    __name(escapeHtml, "escapeHtml");
    function init(scope) {
      var container = scope && scope.querySelectorAll ? scope : document;
      var roots = container.querySelectorAll("[data-fd-signup]");
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        var id = root.getAttribute("data-fd-section-id");
        if (!id || instances[id]) continue;
        instances[id] = new Instance(root);
      }
    }
    __name(init, "init");
    function destroy(id) {
      if (!instances[id]) return;
      instances[id].destroy();
      delete instances[id];
    }
    __name(destroy, "destroy");
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function() {
        init(document);
      });
    } else {
      init(document);
    }
    document.addEventListener("shopify:section:load", function(event) {
      init(event.target);
    });
    document.addEventListener("shopify:section:unload", function(event) {
      destroy(event.detail && event.detail.sectionId);
    });
    document.addEventListener("shopify:section:reorder", function() {
      init(document);
    });
  })();
})();
